<template>
  <tr @click="handleClick">
    <slot />
  </tr>
</template>
<script setup lang="ts">
type Emits = {
  (e: 'onClicked', event: Event): void
}
const emits = defineEmits<Emits>()
function handleClick(event: Event) {
  emits('onClicked', event)
}
</script>
<style scoped lang="scss">
@use '@/design-system/design-tokens/variables.scss';
tr {
  align-items: center;
  display: flex;
  height: 56px;
  justify-content: space-between;
  padding: 16px;
  &:last-child {
    border-radius: 0 0 8px 8px;
  }
  &:not(:first-child) {
    border-top: 1px solid variables.$color-greyscale-line-grey;
  }
}
</style>
